import content, { getPage } from '../../content.js'

export default
{
    data()
    {
        return {
            pages: [
                getPage('policy'),
                getPage('terms')
            ],
            socials: content.socials,
            mailto: content.mailto
        }
    },

    methods:
    {
        openSubscribe()
        {
            this.eventHub.$emit('subscribe:open')
        }
    }
}